import React, { createContext, useState, useMemo, useContext } from 'react';

const AdTrayContext = createContext();

export function AdTrayProvider({ children }) {
  const [showAdTray, setShowAdTray] = useState(true);
  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);

  const contextValue = useMemo(
    () => ({
      showAdTray,
      setShowAdTray,
      isPaymentSuccess,
      setIsPaymentSuccess,
    }),
    [showAdTray, setShowAdTray, isPaymentSuccess, setIsPaymentSuccess]
  );

  return (
    <AdTrayContext.Provider value={contextValue}>
      {children}
    </AdTrayContext.Provider>
  );
}

export const useAdTray = () => useContext(AdTrayContext);
